global.jQuery = global.$ = require('jquery');
global.Rails = require('@rails/ujs').default;
Rails.start();
require('javascripts/application');
require('stylesheets/application');
require.context('../images', true);